import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  btnSave : {
    marginTop : 5
  },
  boxDrawer : {
    width           : 600,
    backgroundColor : '#f1f3f4',
    height          : '100%',
    [theme.breakpoints.down("xs")]: {
      width : '100%',
    },
  },
  drawerHead : {
    background   : '#fff',
    borderBottom : '1px solid #dadce0',
    padding      : 10,
    '& h2'       : {
      margin     : 0,
      lineHeight : 0,
      fontWeight : 400
    }
  },
  drawerBody : {
    padding : 10
  },
  inputLabel : {
    fontSize : 12,
    marginTop: 15
  },
  selectSites : {
    width : '100%'
  },
  MuiDrawerPaper : {
    width : '100%'
  }
}));